import styled from 'styled-components/macro';
import { ListItemBoxWithHover } from 'components/base/Dropdown/shared/styles';

export const ListItemBox = styled(ListItemBoxWithHover)`
  align-items: center;
  justify-content: space-between;
`;
